import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../prop-types';
import OrderStore from '../../store/OrderStore';

@observer
class TrackingPixels extends Component {
  render() {
    const { orderStore } = this.props;
    const { currentOrder } = orderStore;

    if (
      !currentOrder ||
      currentOrder.is_success_seen ||
      currentOrder.tracking_pixels.length === 0
    ) {
      return null;
    }

    return (
      <Fragment>
        {currentOrder.tracking_pixels.map((pixel, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: pixel }} />
        ))}
      </Fragment>
    );
  }
}

TrackingPixels.propTypes = {
  orderStore: modelOf(OrderStore).isRequired,
};

export default inject('orderStore')(TrackingPixels);
